/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

import $ from 'jquery';
import MicroModal from 'micromodal';

document.addEventListener('DOMContentLoaded', function () {

  // restyle bnpcard button
  const $replacements = $('.bnp-button .button');
  $('.home-bnp-card').each(function () {
    const $bnpcard = $(this);
    const $bnpcardButton = $bnpcard.find('.bnpcard__spacer ~ .link.reverse, .bnpcard__spacer + .button.streamline.full');
    $bnpcardButton.find('svg').remove();
    $bnpcardButton.find('.button__text').text('Build Now');
    $bnpcardButton
      .find('.link__text')
      .text('Build Now')
      .removeClass('link__text')
      .addClass('button__text');

    $bnpcardButton.attr('class', $replacements.attr('class'));
    $bnpcardButton.append($replacements.find('svg').clone(false, false));
    $bnpcardButton.removeClass('hidden');
    $bnpcardButton.addClass('bnpcard__bottom-button');
  });

  const $inventoryPage = $('.page-template-inventory, .home-featured-inventory');

  function relocateCardCta() {
    $('.vehicle').each(function () {
      const $title = $(this).find('.vehicle__title');
      $(this).find('.vehicle__custom-ctas').insertBefore($title);
    });
  }

  function replaceBNPCardClass() {
    const $srpBnpcard = $inventoryPage.find('.bnpcard_srp');
    if ($srpBnpcard.length != 0) {
      $srpBnpcard
        .find('.bnpcard__footer .button')
        .removeClass('btn-outline-ui-0')
        .addClass('btn-brand-3');
    }
  }

  if ($inventoryPage.length != 0) {
    relocateCardCta();
    replaceBNPCardClass();
    $(document).on('post_render_inventory_search_results', function () {
      relocateCardCta();
      replaceBNPCardClass();
    });
  }

  // const $srpPage = $('.page-template-inventory');

  // if ($srpPage.length != 0) {
  //   $srpPage.find('.header__theme-accent').each(function(index) {
  //     if (index == 0) {
  //       $(this).insertAfter('.main > .dsp-script').addClass('srp-accent');
  //     } else {
  //       $(this).remove();
  //     }
  //   });
  // }


  const params = new URLSearchParams(window.location.search);
  const modalId = params.get('openModal');

  const $modal = $(`#${modalId}`);

  if ($modal.length != 0) {
    MicroModal.show(modalId);
    if (window.history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.delete('openModal');
      window.history.replaceState({}, document.title, url.pathname + url.hash);
    }
  }
});

document.addEventListener('click', function (e) {
  const trigger = e.target.closest(
    '[data-micromodal-trigger="modal-phone-menu"], [data-micromodal-trigger="modal-contact-menu"]'
  );

  if (!trigger) {
    return;
  }

  const targetModalId = trigger.getAttribute('data-micromodal-trigger');

  e.preventDefault();
  e.stopImmediatePropagation();

  // Close every modal that is currently open.
  $('.modal.is-open').each(function () {
    const id = this.getAttribute('id');

    if (id) {
      MicroModal.close(id);
    }
  });

  $('.js-route-back').attr('data-back-to', '');
  $('.modal').removeClass('is-open');
  $('.modal').attr('aria-hidden', 'true');

  MicroModal.show(targetModalId);

}, true);


// Keep the existing X button behavior, but clear any route state after
// the parent theme has finished closing the modal.
//
$(document).on('click', '.js-close-all-modals', function () {
  setTimeout(function () {
    $('.js-route-back').attr('data-back-to', '');
    $('.modal').removeClass('is-open');
  }, 0);
});
